module.exports = __webpack_public_path__ + "img/1+1-Tafel_A5.653e02f0.png";